const colors = [
  { id: 1, name: "green", dim: "rgba(0,255,0,0.2)", bright: "rgba(0,255,0,1)" },
  { id: 2, name: "red", dim: "rgba(255,0,0,0.2)", bright: "rgba(255,0,0,1)" },
  { id: 3, name: "blue", dim: "rgba(0,0,255,0.2)", bright: "rgba(0,0,255,1)" },
  {
    id: 4,
    name: "yellow",
    dim: "rgba(255,255,0,0.2)",
    bright: "rgba(255,255,0,1)"
  }
];

export { colors };
